import { Mail, Instagram, Linkedin, MessageCircle, Facebook } from "lucide-react";
const Footer = () => {
  return <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold mb-4">Ace Anchor</h3>
            <p className="text-primary-foreground/80 text-sm mb-4">
              One stop solution, doesn't matter what!
            </p>
            <p className="text-primary-foreground/60 text-xs">
              Making every student's Australian journey safe, smooth, and successful.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/#hero" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Home
                </a>
              </li>
              <li>
                <a href="/#about" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  About Us
                </a>
              </li>
              <li>
                <a href="/#services" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Our Plans
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Contact
                </a>
              </li>
              <li>
                <a href="/blog" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">
              Support
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/#faq" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Get in Touch
                </a>
              </li>
              <li>
                <a href="/terms" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="/privacy" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/booking" className="text-primary-foreground/80 hover:text-primary-foreground transition-colors text-sm">
                  Book Now
                </a>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">
              Follow Us
            </h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/aceanchorau/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/ace-anchor/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61583164541750" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://wa.me/61403601970" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="WhatsApp">
                <MessageCircle className="w-5 h-5" />
              </a>
              <a href="mailto:info@aceanchorau.com" className="w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 flex items-center justify-center transition-colors" aria-label="Email">
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <div className="mt-6">
              <p className="text-xs text-primary-foreground/60 mb-2">
                Emergency Support 24/7
              </p>
              <a 
                href="https://wa.me/61403601970" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm font-semibold hover:text-primary-foreground/80 transition-colors inline-flex items-center gap-2"
              >
                <MessageCircle className="w-4 h-4" />
                +61 0403 601 970
              </a>
            </div>
          </div>
        </div>

        {/* Consultation CTA */}
        <div className="border-t border-primary-foreground/10 pt-8 pb-8">
          <div className="text-center space-y-3 max-w-2xl mx-auto">
            <p className="text-lg font-semibold text-primary-foreground">
              Need help? Speak to our founders directly.
            </p>
            <p className="text-sm text-primary-foreground/70 italic">
              Consultation calls are limited and reserved for serious students planning to travel in upcoming intakes.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 pt-8 text-center space-y-3">
          <p className="text-sm text-primary-foreground/70">
            © 2025 Ace Anchor Pty Ltd | ABN 64 692 611 635
          </p>
          <p className="text-sm text-primary-foreground/70">
            Registered in Melbourne, Victoria, Australia
          </p>
          <p className="text-sm text-primary-foreground/70">
            <a href="mailto:support@aceanchorau.com" className="hover:text-primary-foreground transition-colors">
              support@aceanchorau.com
            </a>
            {" | "}
            <a href="https://www.aceanchorau.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground transition-colors">
              www.aceanchorau.com
            </a>
          </p>
          <p className="text-xs text-primary-foreground/60 mt-4 pt-4 border-t border-primary-foreground/10 max-w-2xl mx-auto">
            Disclaimer: Ace Anchor is not a migration or education consultancy. We provide independent concierge services only.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;